import React, { FC } from 'react'
import { Box, BoxProps } from '@mui/material'

export const ContentBox: FC<BoxProps> = ({ children, ...restProps }) => {
  return (
    <Box px={{ xs: 2, sm: 8 }} py={{ xs: 2, sm: 6 }} width="100%" {...restProps}>
      {children}
    </Box>
  )
}
